import type { Locale } from "date-fns/locale";
import { ar, ca, de, enGB, enUS, es, fr, frCA, it, nl, zhCN } from "date-fns/locale";

const DATE_FNS_LOCALES: Record<string, Locale> = {
  ar,
  ca,
  de,
  en: enUS,
  "en-GB": enGB,
  es,
  "es-419": es,
  fr,
  "fr-CA": frCA,
  it,
  nl,
  zh: zhCN,
};

export const getDateFnsLocale = (language?: string): Locale => {
  if (!language) {
    return enUS;
  }

  return DATE_FNS_LOCALES[language] ?? DATE_FNS_LOCALES[language.split("-")[0]] ?? enUS;
};
